var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 1.25L14.25 3.75",
    stroke: "#475467",
    strokeOpacity: 0.3,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6746 12.9522C4.86543 12.9002 4.96085 12.8742 5.04983 12.8342C5.12884 12.7988 5.20394 12.7552 5.27394 12.7042C5.35277 12.6467 5.42271 12.5768 5.56258 12.4369L12.021 5.97855C12.1447 5.8548 12.2066 5.79292 12.2298 5.72157C12.2502 5.6588 12.2502 5.5912 12.2298 5.52843C12.2066 5.45708 12.1447 5.3952 12.021 5.27145L10.2281 3.47855C10.1043 3.3548 10.0424 3.29292 9.97108 3.26974C9.90832 3.24934 9.84071 3.24934 9.77794 3.26974C9.70659 3.29292 9.64471 3.3548 9.52096 3.47855L3.06258 9.93694C2.92271 10.0768 2.85277 10.1467 2.79533 10.2256C2.74434 10.2956 2.70075 10.3707 2.66528 10.4497C2.62533 10.5387 2.59931 10.6341 2.54726 10.8249L1.74951 13.75L4.6746 12.9522Z",
    stroke: "#475467",
    strokeOpacity: 0.3,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.99559a91779852240656d943dc26413f.svg";
export { ForwardRef as ReactComponent };